module.exports = __webpack_public_path__ + "static/gatku-4-7da59e84546ec2f2d47cd9b82087e4d9.jpg";